<template>
  <a-select :options="options" :compress="compress" v-model.sync="localValue" :is-searchable="false" v-bind="$attrs"></a-select>
</template>

<script lang="ts">
  import Vue from "vue";
  import LocalValueEmissionMixin from "../mixins/localValueEmissionMixin";

  export default Vue.extend({
    inheritAttrs: false, // passes through all props and attrs for a-select
    mixins: [LocalValueEmissionMixin],
    props: {
      compress: {
        type: Boolean,
        default: false
      },
      autoSelect: {
        type: Boolean,
        default: true,
      },
      yesFirst: {
        type: Boolean,
        default: false,
      }
    },
    data() {
      const options = [
        {label: 'No', value: false},
        {label: 'Yes', value: true}
      ]
      return {
        options: this.yesFirst ? options.reverse() : options
      }
    },
    mounted(): void {
      if (this.value === null && this.autoSelect) {
        this.$emit('input', this.options[0].value);
      }
    },
  });
</script>